import { createRoot } from "react-dom/client";
import { createElement } from "react";
import { App } from "./app.component";
import "./styles.css";
import { logger } from "@games/logger-client";

console.log('РАБОТА ЛОГГЕРА ', logger)
console.log('ENV ', process.env.NODE_ENV)
console.log('REACT_APP_SOCKET_URL ', process.env.REACT_APP_SOCKET_URL)
// Выводим информацию о запуске приложения и уровне логирования
logger.info(`🚀 Application starting... Log level: ${process.env.REACT_APP_LOG_LEVEL || (process.env.NODE_ENV === "production" ? "warn" : "trace")}`);

const element = document.getElementById("root")!;
const root = createRoot(element);

root.render(createElement(App));